import React from "react";
import { useEffect } from "react";
import Menu from "../Manu/Menu";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import errro from "../../assets/img/404 Error.gif";
import { useTranslation } from "react-i18next";
export default function NotFound() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const { t } = useTranslation();
    return (
        <>
            <Header />

            <div style={styles.wrapper}>

                {/* 🔴 404 Error GIF on Top */}
                <img
                    src={errro}
                    alt="404 Error"
                    style={styles.gif}
                />

                {/* 🔴 Text Section */}
                <h2 style={styles.title}>{t("oops_something_went_wrong")}</h2>
                <p style={styles.subtitle}>
                    {t("we_cant_find_the_page_you_are_looking_for")}
                </p>

                {/* 🔴 Red Back Button */}
                <Link to="/" style={styles.button}>
                    {t("back_home")}
                </Link>
            </div>

            <Footer />
        </>
    );
}

const styles = {
    wrapper: {
        textAlign: "center",
        padding: "40px 20px",
    },
    gif: {
        height: "400px",
        marginBottom: "20px",
    },
    title: {
        fontSize: "22px",
        color: "#777",
        fontWeight: "600",
        marginBottom: "8px",
    },
    subtitle: {
        fontSize: "18px",
        color: "#999",
        fontWeight: "600",
        marginBottom: "20px",
    },
    button: {
        display: "inline-block",
        backgroundColor: "#ec174f",
        color: "#fff",
        padding: "12px 70px",
        borderRadius: "50px",
        fontSize: "16px",
        fontWeight: "600",
        textDecoration: "none",
        marginTop: "10px",
        marginBottom: "30px",
    }
};
